import { FC } from 'react';
import { HeaderStyled } from './style';
const Header: FC<{ children: any }> = ({ children, ...restProps }) => (
  <HeaderStyled {...restProps}>{children}</HeaderStyled>
);

export default Header;
